import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

const Audits = () => (
  <div>
    <Breadcrumbs crumbs={[{title: 'Audits'}]}/>
    <Paper>
      <Table/>
    </Paper>
  </div>
);

export default Audits;
